function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter0_f_52518_48133)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M750 500C717.17 500 684.661 506.466 654.329 519.03C623.998 531.594 596.438 550.009 573.223 573.223C550.009 596.438 531.594 623.998 519.03 654.329C506.466 684.661 500 717.17 500 750C500 782.83 506.466 815.339 519.03 845.671C531.594 876.002 550.009 903.562 573.223 926.777C596.438 949.991 623.998 968.406 654.329 980.97C684.661 993.534 717.17 1000 750 1000L750 500Z",
  fill: "url(#paint0_linear_52518_48133)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_52518_48133",
  x: 0,
  y: 0,
  width: 1250,
  height: 1500,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 250,
  result: "effect1_foregroundBlur_52518_48133"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_52518_48133",
  x1: 625,
  y1: 500,
  x2: 625,
  y2: 1000,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4,
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#007AFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF",
  stopOpacity: 0
})));

function SvgRightGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 1500,
    viewBox: "0 0 750 1500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGradient);
export default __webpack_public_path__ + "static/media/RightGradient.ae365efc916f9727b097e7d61b4ef301.svg";
export { ForwardRef as ReactComponent };